import NBType, { InferType } from '@netbase/nb-type'
import MetricSeriesSchema from './MetricSeriesSchema'

const MetricSchema = NBType.object().shape('MetricSchema', {
  /* @prop */
  columns: NBType.array().of(NBType.timestamp()).nullable(),
  /* @prop */
  dataset: NBType.array().of(MetricSeriesSchema),
  /* @prop */
  timeUnit: NBType.string()
  /* END */
})
export default MetricSchema
export type Metric = InferType<typeof MetricSchema>
// RESERVE BELOW
